import React, { FC, ReactElement } from "react"

// Shared Components
import Button, { BUTTON_VARIANTS } from "@components/Button/Button"

// Styled components
import {
  InterviewBuilderContentARTICLE,
  InterviewBuilderContentActionsDIV,
  InterviewBuilderContentDIV,
} from "./InterviewBuilderContent.styles"

type InterviewBuilderContentProps = {
  children: ReactElement,
  title: string,
  actions: {
    title: string,
    onClick?: () => void,
    href?: string,
  }[],
}

const InterviewBuilderContent: FC<InterviewBuilderContentProps> = ({
  children,
  title,
  actions,
}) => {
  return (
    <InterviewBuilderContentARTICLE>
      <div className="container">
        <div className="grid">
          <div className="column column--2-12-S column--1-5-L">
            <InterviewBuilderContentActionsDIV>
              <h2 className="font--h3">{title}</h2>
              {actions.length > 0 && actions.map((action, i) => (
                <Button
                  href={action.href}
                  key={action.title}
                  onClick={action.onClick}
                  variant={i > 0 ? BUTTON_VARIANTS.SECONDARY : BUTTON_VARIANTS.PRIMARY}
                >
                  {action.title}
                </Button>
              ))}
            </InterviewBuilderContentActionsDIV>
          </div>
          <div className="column column--2-12-S column--5-13-L">
            <InterviewBuilderContentDIV>
              {children}
            </InterviewBuilderContentDIV>
          </div>
        </div>
      </div>
    </InterviewBuilderContentARTICLE>
  )
}

export default InterviewBuilderContent
